import { ApiError } from '../api/client';

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * The message for a failed sign-in, from the server's code: the sign-in page and the join page's
 * "I already have an account" both show it. After too many failures the server makes sign-in wait
 * (tooManyAttempts, with retryAfterSeconds), and the message says for how many minutes.
 */
export function signInErrorText(error: unknown, t: Translate): string | null {
  if (!error) return null;
  const code = error instanceof ApiError ? error.code : undefined;
  switch (code) {
    case 'invalidCredentials':
      return t('login.invalidCredentials');
    case 'tooManyAttempts': {
      const seconds = error instanceof ApiError ? error.retryAfterSeconds : undefined;
      return t('login.tooManyAttempts', { count: Math.max(1, Math.ceil((seconds ?? 900) / 60)) });
    }
    case 'accountDeactivated':
      return t('login.deactivated');
    case 'adminSetupRequired':
      return t('login.adminSetupRequired');
    case 'invalidCode':
      return t('login.invalidCode');
    case 'codeExpired':
      return t('login.codeExpired');
    default:
      return t('login.failed');
  }
}
